/**
 * @import {LightboxItem} from '../model/lightbox-item';
 */
import {Context} from '@acng/frontend-relativity';

/**
 * @type {Local<?LightboxItem>}
 */
export const ctxLightboxItem = Context();
